import {createModelSchema, alias} from "serializr";
import {SmartOfferBundle} from "../bundle-core/SmartOfferBundle";
import {SmartOfferBundleKind} from "../bundle-core/SmartOfferBundleKind";
import {RewardTrack} from "@/modules/redactor/models/reward/RewardTrack";
import {PlinkoGameConfig} from "@/modules/redactor/models/smart-offer/bundle-plinko/PlinkoGameConfig";
import {PlinkoExchangeConfig} from "@/modules/redactor/models/smart-offer/bundle-plinko/PlinkoExchangeConfig";


export class SmartOfferBundleChristmasCalendar extends SmartOfferBundle {

    constructor() {
        super(SmartOfferBundleKind.CHRISTMAS_CALENDAR);

        this._track = null;
    }

    get track() {
        return this._track;
    }

    set track(value) {
        this._track = value;
    }

    valid() {

        if (this.track && !this.track.valid()) {
            return false;
        }

        return super.valid();
    }

    empty() {

        return super.empty();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new SmartOfferBundleChristmasCalendar());
        } else if (target instanceof SmartOfferBundleChristmasCalendar) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(SmartOfferBundleChristmasCalendar, {
    _track: alias("track", RewardTrack.schema()),
});
